import { render } from "./TiptapView.vue?vue&type=template&id=5afe0bae"
import script from "./TiptapView.vue?vue&type=script&lang=js"
export * from "./TiptapView.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/app/app/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__